import React from "react";
import {
  Container,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Button,
} from "shards-react";

import FormDeatils from "../../components/FormDeatils/FormDeatils";
import SideImage from "../../assits/delivery.svg";
import MainFooter from "../../components/layout/MainFooter/MainFooter";

const HomePage = () => {
  return (
    <Container className="justify-content-center align-middle pt-5" id="home">
      <Col className="pt-3 mt-3">
        <Row className="justify-content-end pb-3">
          <a href="/sign-in">
            <Button outline theme="primary">
              Admin
            </Button>
          </a>
        </Row>
        <Row>
          <h1 className="text-primary">Accès illimité</h1>
        </Row>
        <Row>
          <Col md="6">
            <Row>
              <p>
                Êtes-vous un étudiant qui est resté devant l'option d'étude à
                distance?
              </p>
              <p>
                Et vous n'avez pas accès à Internet pour être en ligne avec vos
                professeurs?
              </p>
              <p>
                Nous sommes là pour vous aider à accéder à internet pour
                poursuivre vos études,
              </p>
              <p>Inscrivez-vous aujourd'hui pour bénéficier de ce service</p>
            </Row>
            <Row>
              <ListGroup flush>
                <ListGroupItem className="pt-3 pl-0">
                  <Row>
                    <Col>
                      <FormDeatils />
                    </Col>
                  </Row>
                </ListGroupItem>
              </ListGroup>
            </Row>
          </Col>
          <Col md="6" className="d-none d-md-block">
            <img src={SideImage} alt="delivery guy " />
          </Col>
        </Row>
        <Row className="justify-content-end">
          <MainFooter />
        </Row>
      </Col>
    </Container>
  );
};

export default HomePage;
